import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchContents, fetchFeed } from '../store/contentSlice';
import ContentGrid from '../components/ContentGrid';
import { Link } from 'react-router-dom';

export default function Home() {
  const dispatch = useDispatch();
  const { items, loading, feedItems, feedLoading } = useSelector((state) => state.content);
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(fetchContents({ limit: 12 }));
    if (user) {
      dispatch(fetchFeed({ limit: 12 }));
    }
  }, [dispatch, user]);

  return (
    <div className="home-page">
      <section className="hero">
        <p>Decentralized audiovisual content. Pay with USDC, support creators directly.</p>
        <Link to="/explore" className="btn btn-primary">Explore content</Link>
      </section>

      {user && feedItems.length > 0 && (
        <section className="home-catalog">
          <h2>My Feed</h2>
          <ContentGrid items={feedItems} loading={feedLoading} />
        </section>
      )}

      {user && !feedLoading && feedItems.length === 0 && (
        <section className="home-catalog">
          <p style={{ color: '#aaa', textAlign: 'center', padding: '20px 0' }}>
            Subscribe to creators to see their content here
          </p>
        </section>
      )}

      <section className="home-catalog">
        <h2>{user && feedItems.length > 0 ? 'Discover' : 'Recent content'}</h2>
        <ContentGrid items={items} loading={loading} />
      </section>
    </div>
  );
}
